export function icitInitStackSlider( element ) {

    const slider = element;
    // Check if the slider exists to prevent errors
    if (!slider) return;

    const items = Array.from(slider.children);

    // Duplicate the items to create a seamless loop
    items.forEach(item => {
        const clone = item.cloneNode(true);
        slider.appendChild(clone);
    });

    // GSAP Animation
    const slideTween = gsap.to(slider, {
        x: -slider.scrollWidth / 2, // Move the slider by half its total width
        ease: 'none',
        duration: 40, // Adjust duration for speed (higher value = slower)
        repeat: -1, // Infinite loop
        paused: false, // Start the animation immediately
    });

    // Pause and resume on hover with smooth transition
    const sliderContainer = element.parentNode;

    sliderContainer.addEventListener('mouseenter', () => {
        // Animate the timeScale to smoothly slow down to a complete stop
        gsap.to(slideTween, {
            timeScale: 0, // Animate to a complete stop
            duration: 1.5,
            ease: 'power2.out'
        });
    });

    sliderContainer.addEventListener('mouseleave', () => {
        // Animate the timeScale to smoothly slow down to a complete stop
        gsap.to(slideTween, {
            timeScale: 1, // Animate to a complete stop
            duration: 1.5,
            ease: 'power2.in'
        });
    });
    
}
